// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-statistics__container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin: 12px 0;
}

.tournament-statistics__scorers,
.tournament-statistics__amonished__cards  {
    background-color: var(--white-color);
    padding: var(--space-and-half);
    border-radius: var(--space-half);
    height: 430px;
    position: relative;
}

.tournament-statistics__amonished {
    display: flex;
    justify-content: space-between;
}

.tournament-statistics__scorers-title {
    display: flex;
    justify-content: space-between;
}

.tournament-statistics__amonished__cards-container {
    display: inline-flex;
    align-items: center;
}

.tournament-statistics__no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 140px;
}

.tournament-statistics__no-data .baloa-normal {
    color: var(--primary-dark-color);
}

.tournament-statistics__scorers-row {
    display: flex;
    align-items: center;
    margin-top: 16px;
    margin-right: 24px;
}

.tournament-statistics__scorers-row__number.baloa-normal-medium {
    color: var(--basic-gray-color);
    margin-right: 16px;
}

.tournament-statistics__scorers-row__goals.baloa-normal-medium {
    color: var(--primary-very-dark-color);
    margin-left: auto;
}

.tournament-statistics__scorers-row .yellow-card {
    background-color: var(--new-yellow-warning-color);
    width: var(--space);
    height: var(--space-and-half);
    margin-left: var(--space-half-quarter);
}

.tournament-statistics__scorers-row .red-card {
    background-color: var(--error-color);
    width: var(--space);
    height: var(--space-and-half);
    margin-left: var(--space-half-quarter);
}

.tournament-statistics__scorers-row .blue-card {
    background-color: #0273FF;
    width: var(--space);
    height: var(--space-and-half);
    margin-left: var(--space-half-quarter);
}

.tournament-statistics__next-button {
    position: absolute;
    bottom: 0;
    padding: 12px;
    text-align: center;
    width: calc(100% - 24px);
    cursor: pointer;
}

.tournament-statistics__next-button.baloa-names {
    color: var(--new-green-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .tournament-statistics__container {
        grid-template-columns:  1fr;
        margin: 0;
        gap: 0;
    }

    .tournament-statistics__scorers{
        margin: 12px;
    }


    .tournament-statistics__amonished-title{
        margin: 12px;
    }
    
    .tournament-statistics__amonished__cards {
        padding: 12px 24px 12px 12px;
        margin: 12px;
    }

    .tournament-statistics__scorers, .tournament-statistics__amonished__cards {
        height: 320px;
    }
        
}

`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-statistics/TournamentStatisticsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,cAAc;AAClB;;AAEA;;IAEI,oCAAoC;IACpC,8BAA8B;IAC9B,gCAAgC;IAChC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,iDAAiD;IACjD,mBAAmB;IACnB,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,2BAA2B;QAC3B,SAAS;QACT,MAAM;IACV;;IAEA;QACI,YAAY;IAChB;;;IAGA;QACI,YAAY;IAChB;;IAEA;QACI,4BAA4B;QAC5B,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;AAEJ","sourcesContent":[".tournament-statistics__container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n    margin: 12px 0;\n}\n\n.tournament-statistics__scorers,\n.tournament-statistics__amonished__cards  {\n    background-color: var(--white-color);\n    padding: var(--space-and-half);\n    border-radius: var(--space-half);\n    height: 430px;\n    position: relative;\n}\n\n.tournament-statistics__amonished {\n    display: flex;\n    justify-content: space-between;\n}\n\n.tournament-statistics__scorers-title {\n    display: flex;\n    justify-content: space-between;\n}\n\n.tournament-statistics__amonished__cards-container {\n    display: inline-flex;\n    align-items: center;\n}\n\n.tournament-statistics__no-data {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 140px;\n}\n\n.tournament-statistics__no-data .baloa-normal {\n    color: var(--primary-dark-color);\n}\n\n.tournament-statistics__scorers-row {\n    display: flex;\n    align-items: center;\n    margin-top: 16px;\n    margin-right: 24px;\n}\n\n.tournament-statistics__scorers-row__number.baloa-normal-medium {\n    color: var(--basic-gray-color);\n    margin-right: 16px;\n}\n\n.tournament-statistics__scorers-row__goals.baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n    margin-left: auto;\n}\n\n.tournament-statistics__scorers-row .yellow-card {\n    background-color: var(--new-yellow-warning-color);\n    width: var(--space);\n    height: var(--space-and-half);\n    margin-left: var(--space-half-quarter);\n}\n\n.tournament-statistics__scorers-row .red-card {\n    background-color: var(--error-color);\n    width: var(--space);\n    height: var(--space-and-half);\n    margin-left: var(--space-half-quarter);\n}\n\n.tournament-statistics__scorers-row .blue-card {\n    background-color: #0273FF;\n    width: var(--space);\n    height: var(--space-and-half);\n    margin-left: var(--space-half-quarter);\n}\n\n.tournament-statistics__next-button {\n    position: absolute;\n    bottom: 0;\n    padding: 12px;\n    text-align: center;\n    width: calc(100% - 24px);\n    cursor: pointer;\n}\n\n.tournament-statistics__next-button.baloa-names {\n    color: var(--new-green-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .tournament-statistics__container {\n        grid-template-columns:  1fr;\n        margin: 0;\n        gap: 0;\n    }\n\n    .tournament-statistics__scorers{\n        margin: 12px;\n    }\n\n\n    .tournament-statistics__amonished-title{\n        margin: 12px;\n    }\n    \n    .tournament-statistics__amonished__cards {\n        padding: 12px 24px 12px 12px;\n        margin: 12px;\n    }\n\n    .tournament-statistics__scorers, .tournament-statistics__amonished__cards {\n        height: 320px;\n    }\n        \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
